import {list, detail} from "@mc/mc-legacy";
import SubjektApi from "../api/gen/cgo/SubjektApi";

export const SPOLECNOSTI_LIST_AREA = "spolecnostiList";
export const SPOLECNOST_ZAMESTNANCI_LIST_AREA = "spolecnostZamestnanciList";
export const SPOLECNOST_ADRESY_LIST_AREA = "spolecnostAdresyList";
export const SPOLECNOST_AKTIVNI_ADRESY_LIST_AREA = "spolecnostAktivniAdresyList";
export const SPOLECNOST_KARTY_LIST_AREA = "spolecnostKartyList";
export const SPOLECNOST_DETAIL_AREA = "spolecnostDetail";
export const SPOLECNOST_ADRESA_AREA = "spolecnostAdresaDetail";
export const SPOLECNOST_RIGHTS_AREA = "spolecnostRightsDetail";
export const SPOLECNOST_POBOCKY_VYDEJ_LIST_AREA = "spolecnostPobockyVydejList";
export const SPOLECNOST_POBOCKY_VYDEJ_VCETNE_VYDEJNI_LIST_AREA = "spolecnostPobockyVydejniVcetneVydejniList";
export const UZIVATELE_LIST_AREA = "uzivateleList";
export const UZIVATEL_DETAIL_AREA = "uzivatelDetail";
export const UZIVATEL_ADRESY_LIST_AREA = "uzivatelAdresyList";
export const UZIVATEL_AKTIVNI_ADRESY_LIST_AREA = "uzivatelAktivniAdresyList";
export const UZIVATEL_SPOLECNOSTI_LIST_AREA = "uzivatelSpolecnostiList";
export const UZIVATEL_KARTY_LIST_AREA = "uzivatelKartyList";
export const UZIVATEL_AKTIVNI_SPOLECNOST_AREA = "uzivatelAktivniSpolecnostDetail";
export const UZIVATEL_ADRESA_AREA = "uzivatelAdresaDetail";
export const UZIVATEL_RIGHTS_AREA = "uzivatelRightsDetail";
export const UZIVATEL_VYCHOZI_HODNOTY_AREA = "uzivatelVychoziHodnotyDetail";

// Limity určující kolik výsledků maximálně vrací server, používají se pro zobrazení upozornění uživateli pokud je jich
// vráceno právě tolik a tudíž uživatel nevidí v seznamu všechny.
export const UZIVATELE_FETCH_LIMIT = 500;
export const SPOLECNOSTI_FETCH_LIMIT = 500;

/**
 * Načtení seznamu společností.
 * @returns {Function}
 */
export function fetchSpolecnostiIfNeeded() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(SPOLECNOSTI_LIST_AREA, null, (parent, filter) => {
            return SubjektApi.getSpolecnosti(
                filter.fulltext ? filter.fulltext : null, filter.vcetneNeaktivnich ? null : false
                );
        }));
    }
}

/**
 * Zneplatnění seznamu společností.
 * @returns {Function}
 */
export function invalidateSpolecnosti() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(SPOLECNOSTI_LIST_AREA));
    }
}

/**
 * Filtrování společností.
 * @param filter filtr
 * @returns {Function}
 */
export function filterSpolecnosti(filter) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.filter(SPOLECNOSTI_LIST_AREA, filter));
    }
}

/**
 * Načtení detailu společnosti.
 * @param id ID společnosti
 * @returns {function(*): *}
 */
export const fetchSpolecnostDetailIfNeeded = (id) => {
    return (dispatch) => {
        return dispatch(detail.DetailActions.fetchIfNeeded(SPOLECNOST_DETAIL_AREA, id, (parent) => {
            return SubjektApi.getSpolecnost(parent);
        }));
    }
};

/**
 * Zneplatnění detailu společnosti.
 *
 * @param id ID společnosti
 * @returns {function(*)}
 */
export const invalidateSpolecnostDetail = (id) => {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(SPOLECNOST_DETAIL_AREA, id));
    }
};

/**
 * Načtení detailu aktivní společnosti.
 * @param id ID společnosti
 * @returns {function(*): *}
 */
export const fetchAktivniSpolecnostDetailIfNeeded = (id) => {
    return (dispatch) => {
        return dispatch(detail.DetailActions.fetchIfNeeded(UZIVATEL_AKTIVNI_SPOLECNOST_AREA, id, (parent) => {
            return SubjektApi.getSpolecnost(parent);
        }));
    }
};

/**
 * Zneplatnění detailu společnosti.
 *
 * @param spolecnostId ID společnosti
 * @returns {function(*)}
 */
export function invalidateAktivniSpolecnostDetail(spolecnostId) {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(UZIVATEL_AKTIVNI_SPOLECNOST_AREA, spolecnostId));
    }
}

/**
 * Načtení seznamu uživatelů společnosti.
 * @returns {Function}
 */
export function fetchUzivateleSpolecnostIfNeeded(spolecnostId) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(SPOLECNOST_ZAMESTNANCI_LIST_AREA, spolecnostId, (parent) => {
            return SubjektApi.getUzivateleSpolecnost(parent);
        }));
    }
}

/**
 * Zneplatnění seznamu uživatelů společnosti.
 * @returns {Function}
 */
export function invalidateUzivateleSpolecnosti() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(SPOLECNOST_ZAMESTNANCI_LIST_AREA));
    }
}

/**
 * Načtení seznamu adres společnosti.
 * @returns {Function}
 */
export function fetchAdresySpolecnostIfNeeded(spolecnostId) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(SPOLECNOST_ADRESY_LIST_AREA, spolecnostId, (parent) => {
            return SubjektApi.getAdresySpolecnost(parent, null);
        }));
    }
}

/**
 * Zneplatnění seznamu adres společnosti.
 * @returns {Function}
 */
export function invalidateAdresySpolecnost() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(SPOLECNOST_ADRESY_LIST_AREA));
    }
}

/**
 * Načtení seznamu aktivních adres společnosti.
 * @returns {Function}
 */
export function fetchAktivniAdresySpolecnostIfNeeded(spolecnostId) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(SPOLECNOST_AKTIVNI_ADRESY_LIST_AREA, spolecnostId, (parent) => {
            return SubjektApi.getAdresySpolecnost(parent, false);
        }));
    }
}

/**
 * Zneplatnění seznamu aktivních adres společnosti.
 * @returns {Function}
 */
export function invalidateAktivniAdresySpolecnost() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(SPOLECNOST_AKTIVNI_ADRESY_LIST_AREA));
    }
}

/**
 * Načtení seznamu karet společnosti.
 * @returns {Function}
 */
export function fetchKartySpolecnostIfNeeded(spolecnostId, neaktivni) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(SPOLECNOST_KARTY_LIST_AREA, spolecnostId, (parent) => {
            return SubjektApi.getKartySpolecnost(parent, neaktivni);
        }));
    }
}

/**
 * Zneplatnění seznamu karet společnosti.
 * @returns {Function}
 */
export function invalidateKartySpolecnosti() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(SPOLECNOST_KARTY_LIST_AREA));
    }
}

/**
 * Načtení seznamu uživatelů.
 * @returns {Function}
 */
export function fetchUzivateleIfNeeded() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(UZIVATELE_LIST_AREA, null, (parent, filter) => {
            return SubjektApi.getUzivatele(filter.fulltext ? filter.fulltext : null, null, null);
        }));
    }
}

/**
 * Zneplatnění seznamu uživatelů.
 * @returns {Function}
 */
export function invalidateUzivatele() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(UZIVATELE_LIST_AREA));
    }
}

/**
 * Filtrování uživatelů.
 * @param filter filtr
 * @returns {Function}
 */
export function filterUzivatele(filter) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.filter(UZIVATELE_LIST_AREA, filter));
    }
}

/**
 * Načtení detailu uživatele.
 * @param id ID uživatele
 * @returns {function(*): *}
 */
export const fetchUzivatelDetailIfNeeded = (id) => {
    return (dispatch) => {
        return dispatch(detail.DetailActions.fetchIfNeeded(UZIVATEL_DETAIL_AREA, id, (parent) => {
            return SubjektApi.getUzivatel(parent);
        }));
    }
};

/**
 * Zneplatnění detailu uživatele.
 *
 * @param id ID uživatele
 * @returns {function(*)}
 */
export const invalidateUzivatelDetail = (id) => {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(UZIVATEL_DETAIL_AREA, id));
    }
};

/**
 * Načtení seznamu všech adres uživatele (včetně neaktivních).
 *
 * @param uzivatelId ID uživatele
 * @returns {Function}
 */
export function fetchAdresyUzivatelIfNeeded(uzivatelId) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(UZIVATEL_ADRESY_LIST_AREA, uzivatelId, (parent) => {
            return SubjektApi.getAdresyUzivatel(parent, null, null);
        }));
    }
}

/**
 * Zneplatnění seznamu adres uživatele.
 *
 * @returns {Function}
 */
export function invalidateAdresyUzivatel() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(UZIVATEL_ADRESY_LIST_AREA));
    }
}

/**
 * Načtení seznamu aktivních adres uživatele a případně jeho aktivní společnosti.
 *
 * @param uzivatelId ID uživatele
 * @param spolecnostId ID společnosti dle které
 * @returns {Function}
 */
export function fetchAktivniAdresyUzivatelIfNeeded(uzivatelId, spolecnostId) {
    const id = spolecnostId ? uzivatelId.toString() + spolecnostId.toString() : uzivatelId;
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(UZIVATEL_AKTIVNI_ADRESY_LIST_AREA, id, () => {
            return SubjektApi.getAdresyUzivatel(uzivatelId, spolecnostId, false);
        }));
    }
}

/**
 * Zneplatnění seznamu aktivních adres uživatele.
 *
 * @returns {Function}
 */
export function invalidateAktivniAdresyUzivatel() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(UZIVATEL_AKTIVNI_ADRESY_LIST_AREA));
    }
}

/**
 * Načtení seznamu společností uživatele.
 *
 * @param uzivatelId ID uživatele
 * @returns {Function}
 */
export function fetchSpolecnostiUzivatelIfNeeded(uzivatelId) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(UZIVATEL_SPOLECNOSTI_LIST_AREA, uzivatelId, (parent) => {
            return SubjektApi.getSpolecnostiUzivatel(parent, false);
        }));
    }
}

/**
 * Zneplatnění seznamu společností uživatele.
 *
 * @returns {Function}
 */
export function invalidateSpolecnostiUzivatel() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(UZIVATEL_SPOLECNOSTI_LIST_AREA));
    }
}

/**
 * Načtení seznamu karet uživatele.
 *
 * @param id ID uživatele
 * @returns {Function}
 */
export function fetchKartyUzivatelIfNeeded(id, neaktivni) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(UZIVATEL_KARTY_LIST_AREA, id, (parent) => {
            return SubjektApi.getKartyUzivatel(parent, neaktivni);
        }));
    }
}

/**
 * Zneplatnění seznamu karet uživatele.
 *
 * @returns {Function}
 */
export function invalidateKartyUzivatel() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(UZIVATEL_KARTY_LIST_AREA));
    }
}

/**
 * Aktualizace uživatele.
 * Při aktualizaci uživatele záměrně nechceme na server posílat atribut zobrazJmeno, protože na formuláři ho nezobrazujeme
 * a zůstalo by proto stejné jako původní - když je null, tak se na serveru znovu vyplní z ostatních údajů.
 *
 * @param data data formuláře
 */
export function updateUzivatel(data) {
    const newData = {...data};
    delete newData.zobrazJmeno;
    return SubjektApi.updateUzivatel(newData, newData.id);
}

/**
 * Načtení detailu adresy uživatele.
 *
 * @param uzivatelId ID uživatele
 * @param adresaId ID adresy
 * @returns {function(*): *}
 */
export const fetchAdresaUzivatelIfNeeded = (uzivatelId, adresaId) => {
    return (dispatch) => {
        return dispatch(detail.DetailActions.fetchIfNeeded(UZIVATEL_ADRESA_AREA, adresaId, (parent) => {
            return SubjektApi.getAdresaUzivatel(uzivatelId, parent, null);
        }));
    }
};

/**
 * Zneplatnění detailu adresy uživatele.
 *
 * @param adresaId ID adresy
 * @returns {function(*)}
 */
export const invalidateAdresaUzivatel = (adresaId) => {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(UZIVATEL_ADRESA_AREA, adresaId));
    }
};

/**
 * Načtení oprávnění na uživatele.
 *
 * @param uzivatelId ID uživatele
 * @returns {function(*): *}
 */
export const fetchUzivatelRightsIfNeeded = (uzivatelId) => {
    return (dispatch) => {
        return dispatch(detail.DetailActions.fetchIfNeeded(UZIVATEL_RIGHTS_AREA, uzivatelId, (parent) => {
            return SubjektApi.getUzivatelRights(parent);
        }));
    }
};

/**
 * Zneplatnění oprávnění na uživatele.
 *
 * @param uzivatelId ID uživatele
 * @returns {function(*)}
 */
export const invalidateUzivatelRights = (uzivatelId) => {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(UZIVATEL_RIGHTS_AREA, uzivatelId));
    }
};

/**
 * Načtení detailu adresy společnosti.
 *
 * @param spolecnostId ID společnosti
 * @param adresaId ID adresy
 * @returns {function(*): *}
 */
export const fetchAdresaSpolecnostIfNeeded = (spolecnostId, adresaId) => {
    return (dispatch) => {
        return dispatch(detail.DetailActions.fetchIfNeeded(SPOLECNOST_ADRESA_AREA, adresaId, (parent) => {
            return SubjektApi.getAdresaSpolecnost(spolecnostId, parent);
        }));
    }
};

/**
 * Zneplatnění detailu adresy společnosti.
 *
 * @param adresaId ID adresy
 * @returns {function(*)}
 */
export const invalidateAdresaSpolecnost = (adresaId) => {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(SPOLECNOST_ADRESA_AREA, adresaId));
    }
};

/**
 * Načtení oprávnění na společnost.
 *
 * @param spolecnostId ID společnosti
 * @returns {function(*): *}
 */
export const fetchSpolecnostRightsIfNeeded = (spolecnostId) => {
    return (dispatch) => {
        return dispatch(detail.DetailActions.fetchIfNeeded(SPOLECNOST_RIGHTS_AREA, spolecnostId, (parent) => {
            return SubjektApi.getSpolecnostRights(parent);
        }));
    }
};

/**
 * Zneplatnění oprávnění na společnost.
 *
 * @param spolecnostId ID společnosti
 * @returns {function(*)}
 */
export const invalidateSpolecnostRights = (spolecnostId) => {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(SPOLECNOST_RIGHTS_AREA, spolecnostId));
    }
};

/**
 * Načtení výchozích hodnot uživatele.
 * @param uzivatelId ID uživatele
 * @param spolecnostId ID společnosti
 * @returns {function(*): *}
 */
export const fetchUzivatelVychoziHodnotyIfNeeded = (uzivatelId, spolecnostId) => {
    return (dispatch) => {
        return dispatch(detail.DetailActions.fetchIfNeeded(UZIVATEL_VYCHOZI_HODNOTY_AREA, uzivatelId + spolecnostId, () => {
            return SubjektApi.getUzivatelVychoziHodnoty(uzivatelId, spolecnostId);
        }));
    }
};

/**
 * Zneplatnění výchozích hodnot uživatele.
 *
 * @param uzivatelId ID uživatele
 * @param spolecnostId ID společnosti
 * @returns {function(*)}
 */
export const invalidateUzivatelVychoziHodnotyDetail = (uzivatelId, spolecnostId) => {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(UZIVATEL_VYCHOZI_HODNOTY_AREA, uzivatelId + spolecnostId));
    }
};

/**
 * Načtení seznamu výdejních poboček společnosti.
 * @returns {Function}
 */
export function fetchSpolecnostPobockaVydejIfNeeded(spolecnostId) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(SPOLECNOST_POBOCKY_VYDEJ_LIST_AREA, spolecnostId, (parent) => {
            return SubjektApi.getVydejPobockySpolecnosti(parent, false);
        }));
    }
}

/**
 * Načtení seznamu výdejních poboček společnosti.
 * @returns {Function}
 */
export function fetchSpolecnostPobockaVydejVcetneVydejniIfNeeded(spolecnostId) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(SPOLECNOST_POBOCKY_VYDEJ_VCETNE_VYDEJNI_LIST_AREA, spolecnostId, (parent) => {
            return SubjektApi.getVydejPobockySpolecnosti(parent, true);
        }));
    }
}

/**
 * Zneplatnění seznamu výdejních poboček společnosti.
 *
 * @param spolecnostId ID společnosti
 * @returns {function(*)}
 */
export const invalidateSpolecnostPobockaVydej = () => {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(SPOLECNOST_POBOCKY_VYDEJ_LIST_AREA));
    }
};

/**
 * Zneplatnění seznamu výdejních poboček společnosti.
 *
 * @param spolecnostId ID společnosti
 * @returns {function(*)}
 */
export const invalidateSpolecnostPobockaVydejVcetneVydejni = () => {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(SPOLECNOST_POBOCKY_VYDEJ_VCETNE_VYDEJNI_LIST_AREA));
    }
};
